// The words the Main Draw shows for a match write's answer on `matches-response`
// (score, replace, swap and create). A code the page does not know, or a text the
// API let through, is never shown as it is.

const GROUP_RESULT_UNRESOLVED =
  "The score was not saved: the group's winner and runner-up cannot be worked out from these results. Contact support with this group's scores."

const failures = {
  ENTRY_MOVE_OPERATION_IN_PROGRESS:
    "An entry is being added or withdrawn in this competition. Save again once it finishes in Entries → Operations in progress.",
  EVENT_COMPLETION_OPERATION_IN_PROGRESS:
    "The event is being completed. Matches cannot be changed until completion finishes.",
  NON_ADMISSION_OPERATION_IN_PROGRESS:
    "Waiting List entries are being resolved while points are saved. Save again once that finishes.",
  PHASE_OPERATION_IN_PROGRESS:
    "A phase operation is still being completed. Save again once it finishes in Phases.",
  BYE_ON_BOTH_MATCH_SIDES_NOT_PERMITTED:
    "A match cannot have BYE on both sides. Choose a player or team instead of BYE.",
  COMPETITION_HISTORY_UNAVAILABLE:
    "The competition could not be confirmed, so nothing was saved. Save again in a moment.",
  FAILED_TO_GET_FINALIST: GROUP_RESULT_UNRESOLVED,
  FAILED_TO_GET_CHAMPION: GROUP_RESULT_UNRESOLVED,
  MATCH_NOT_FOUND: "This match no longer exists. Reload the Main Draw.",
  COMPETITION_NOT_FOUND:
    "This competition no longer exists or no longer holds this match. Reload the Main Draw.",
  MATCH_WRITE_OPERATION_CONFLICT:
    "This request conflicts with an earlier one. Reload the Main Draw and check the match before saving again.",
  COULD_NOT_CREATE_MATCH:
    "The match could not be created. Reload the Main Draw and review Action Logs before adding it again.",
  COULD_NOT_UPDATE_MATCH:
    "The match could not be saved. Reload the Main Draw and review Action Logs before saving again.",
  DUPLICATE_MATCH_ENTRY: "This player or team is already in the Main Draw.",
  BYE_PATH_ALREADY_PLAYED:
    "A later round fed by this BYE has already been played, so the BYE can no longer be replaced.",
  // Replace, Swap and Create Match name who they saw in the side they change; the side holds
  // someone else by now. The page reloads the Main Draw when this answer arrives.
  MATCH_CONTEXT_CHANGED:
    "This match changed after you opened it, so nothing was saved. The Main Draw has been reloaded; check the match and choose again.",
  SWAP_MATCH_ALREADY_DECIDED:
    "Only players or teams whose matches have no result yet can be swapped. Use Replace for a player who already advanced.",
  // BYE_AGAINST_OPEN_SLOT_NOT_PERMITTED and FAILED_TO_FETCH_MATCH_ENTRY keep the general text:
  // neither dialog offers those actions.
  BYE_ON_OPEN_SLOT_NOT_PERMITTED:
    "BYE can only replace a player or team already in this place. Choose a player or team instead.",
  // A later-round match with a side waiting for an earlier result takes neither a score nor a
  // person there. The Main Draw offers neither, so this comes from an older tab or another app.
  SLOT_WAITS_FOR_EARLIER_RESULT:
    "One side of this match is still waiting for the winner of an earlier match. Enter that result first, then try again.",
}

const NOT_SAVED =
  "The match was not saved. Reload the Main Draw and review Action Logs before saving again."

const successes = {
  SUCCESSFULLY_UPDATED_MATCH: "Match saved.",
  SUCCESSFULLY_CREATED_MATCH: "Match created.",
}

const known = (texts, key) =>
  typeof key === "string" && Object.prototype.hasOwnProperty.call(texts, key)
    ? texts[key]
    : undefined

// Accounts can wrap the code in error classes ("Error: ApiError: FAILED_TO_GET_FINALIST").
const stripErrorPrefix = message =>
  typeof message === "string" ? message.replace(/^(?:[A-Za-z]*Error: )+/, "") : message

export const matchWriteFailure = message =>
  known(failures, stripErrorPrefix(message)) || NOT_SAVED

export const isMatchContextChanged = message =>
  stripErrorPrefix(message) === "MATCH_CONTEXT_CHANGED"

export const matchWriteSuccess = message =>
  known(successes, message) || "Main Draw updated."
